
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punetonashikinnovacrysta() {



    const cardData =
    {
        keyword: 'Pune to Nashik Innova Crysta Taxi Service',
        heading: 'Meghana Cab : Pune to Nashik Innova Crysta Taxi Service',
        headingDescription: 'Meghana Cab offers Pune to Nashik Innova Crysta Taxi Service, delivering a premium, spacious, and hassle-free travel experience to the renowned city of temples, vineyards, and culture. Our Innova Crysta cabs are ideal for family trips, group tours, or business travel—offering plush leather seating, ample legroom, AC comfort, and large luggage space.',


        top: 'Top Places to Visit in Nashik with Meghana Cab',

"topPlaces": [
  {
    "title": "Trimbakeshwar Temple",
    "description": "Located about 28 km from Nashik, Trimbakeshwar Temple is one of the 12 sacred Jyotirlingas of Lord Shiva. The temple is uniquely constructed with black stone and features three faces of Brahma, Vishnu, and Mahesh in the main sanctum. It is also the origin of the Godavari River and a prime spot for Hindu rituals like Narayan Nagbali and Kalsarpa Shanti. The temple attracts pilgrims year-round and especially during Shravan and Maha Shivaratri."
  },
  {
    "title": "Kalaram Temple",
    "description": "Situated in the Panchavati area, the Kalaram Temple is an ancient shrine dedicated to Lord Rama, built in the 18th century. The temple gets its name from the striking black stone idols of Rama, Sita, and Lakshman. Surrounded by a tall stone wall and located near the Godavari Ghats, it holds historical significance as a site of protest during Dr. B.R. Ambedkar’s temple entry movement."
  },
  {
    "title": "Panchavati",
    "description": "Panchavati is a sacred area in Nashik known for its connections to the Ramayana. It’s believed that Lord Rama spent a significant part of his exile here. Key places within Panchavati include the Sita Gufa (cave), Kalaram Temple, Kapaleshwar Temple, and the Godavari Ghats. The area is ideal for a walking pilgrimage filled with devotion, heritage, and spirituality."
  },
  {
    "title": "Sita Gufa",
    "description": "Sita Gufa is a small but deeply revered cave located near Kalaram Temple, believed to be the site where Sita was abducted by Ravana. Inside the cave are idols of Lord Rama, Sita, and Lakshman, along with a narrow tunnel that is said to have been used during their forest stay. Devotees climb down a steep staircase to visit this spiritually significant spot."
  },
  {
    "title": "Ramkund",
    "description": "Ramkund is a holy tank on the banks of the Godavari River, where it is believed Lord Rama performed his father’s last rites. It is a central point for Pind Daan and other Hindu rituals. During Kumbh Mela, millions of devotees gather here to take a dip in the sacred river. The area is dotted with small shrines and is considered the heart of Nashik’s religious life."
  },
  {
    "title": "Saptashrungi Devi Temple",
    "description": "About 60 km from Nashik in Vani, the Saptashrungi Temple is one of the 51 Shakti Peethas in India. Dedicated to Goddess Saptashrungi Nivasini, the temple is located halfway up a hill and can be reached via a ropeway or stair climb of over 500 steps. The idol is carved into a rock and adorned with weapons. The temple draws thousands of devotees during Navratri and other festivals."
  },
  {
    "title": "Anjneri Hill",
    "description": "Believed to be the birthplace of Lord Hanuman, Anjneri Hill lies on the way to Trimbakeshwar and is a favorite trekking destination. The hill offers a combination of mythology and adventure, with temples, caves, waterfalls, and scenic views of the Sahyadri ranges. The hike is moderately challenging and provides a spiritual experience amidst nature."
  },
  {
    "title": "Sula Vineyards",
    "description": "Sula Vineyards is India’s most famous wine destination, located just outside Nashik city. It offers wine tasting, vineyard tours, fine dining, and beautiful views of the Western Ghats. The vineyard also hosts the annual SulaFest—an open-air music and wine festival. It’s a perfect spot for couples, foodies, and leisure travelers looking for a mix of nature, luxury, and gastronomy."
  },
  {
    "title": "Pandav Leni (Pandav Caves)",
    "description": "A set of 24 ancient rock-cut caves located on a hill to the south of Nashik, Pandav Leni dates back to the 3rd century BCE. These Buddhist caves served as viharas (monasteries) and chaityas (prayer halls) for monks. Carved inscriptions and beautiful sculptures make it a rich archaeological site. A staircase leads up to the caves, offering panoramic views of Nashik city."
  },
  {
    "title": "Someshwar Waterfall & Temple",
    "description": "Located along the Gangapur Road, Someshwar is a picturesque locale featuring a Shiva temple and a small waterfall, especially beautiful during the monsoon. The Someshwar Temple is a local favorite for weekend visits, and the nearby Gangapur Dam adds to the scenic beauty. It’s a peaceful place for picnics and short spiritual detours."
  }
],

   "services": [
    {
      "name": "Pune to Nashik Innova Crysta Cab Booking",
      "description": "Plan your journey from Pune to Nashik in luxury with our Innova Crysta cab booking service. Whether you’re heading to the Trimbakeshwar temple, Sula Vineyards, or a business meeting, our cabs offer superior ride quality, spacious interiors, and reliable service. Enjoy a smooth 5-6 hour drive with professional chauffeurs and flexible booking options—ideal for family trips, spiritual tours, or corporate travel."
    },
    {
      "name": "One Way Innova Crysta Pune Nashik",
      "description": "Book a one-way Innova Crysta taxi from Pune to Nashik for a seamless and cost-effective travel experience. Whether you're heading to a wedding, corporate event, or just relocating, our one-way service provides a direct, comfortable, and private ride with no shared passengers or hidden fees."
    },
    {
      "name": "Round Trip Innova Crysta Pune Nashik",
      "description": "Opt for our round-trip Innova Crysta service to Nashik and enjoy complete convenience. This package is perfect for same-day returns or overnight trips, offering you a dedicated cab, courteous driver, and flexibility in schedule. Great for weekend getaways or visits to temples and vineyards."
    },
    {
      "name": "AC Innova Crysta Taxi Pune Nashik",
      "description": "Beat the weather and travel in full comfort with our AC Innova Crysta taxis. Equipped with climate control, comfortable pushback seats, and premium upholstery, your ride from Pune to Nashik will be smooth, relaxing, and enjoyable—no matter the season."
    },
    {
      "name": "Chauffeur Driven Innova Crysta Pune Nashik",
      "description": "Relax and enjoy the journey while our professional chauffeurs take you from Pune to Nashik. Punctual, well-groomed, and trained for long-distance routes, our drivers ensure a safe, smooth, and pleasant ride—perfect for family trips, business travelers, or senior citizens."
    },
    {
      "name": "Private Innova Crysta Taxi Pune Nashik",
      "description": "Avoid crowded buses or shared taxis by booking a private Innova Crysta for your Pune to Nashik travel. This service gives you complete control over your journey with flexible stops, clean interiors, and a peaceful atmosphere throughout the trip."
    },
    {
      "name": "Online Booking Innova Crysta Cab Pune Nashik",
      "description": "Book your Pune to Nashik Innova Crysta cab online within minutes. Our user-friendly platform offers instant confirmations, competitive pricing, and multiple payment methods—allowing you to schedule your trip quickly and securely from the comfort of your home."
    },
    {
      "name": "Family Innova Crysta Trip Pune Nashik",
      "description": "Travel with your loved ones in style and comfort with our family-friendly Innova Crysta cab service to Nashik. The spacious 6/7-seater offers ample luggage room, rear AC vents, and child-safe features—making it the perfect choice for spiritual getaways or family holidays."
    }
  ],
  "tableData": [
    ["Pune to Nashik Innova Crysta Cab Booking", "One Way Innova Crysta Pune Nashik"],
    ["Round Trip Innova Crysta Pune Nashik", "AC Innova Crysta Taxi Pune Nashik"],
    ["Chauffeur Driven Innova Crysta Pune Nashik", "Private Innova Crysta Taxi Pune Nashik"],
    ["Online Booking Innova Crysta Cab Pune Nashik", "Family Innova Crysta Trip Pune Nashik"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Premium Innova Crysta Taxi from Pune to Nashik",
    "WhyChoosedescription": "Travel from Pune to Nashik in comfort and style with our Innova Crysta taxi service. Whether you're visiting for business, a vineyard tour, or a religious trip to Trimbakeshwar, we ensure a smooth, safe, and luxurious journey across the 210+ km route."
  },
  {
    "WhyChooseheading": "Spacious and Comfortable for Long-Distance Travel",
    "WhyChoosedescription": "Innova Crysta is ideal for long journeys, offering seating for 6–7 passengers, large boot space, reclining seats, and rear AC vents. It’s perfect for families, corporate teams, or groups who value comfort and space on the road."
  },
  {
    "WhyChooseheading": "Experienced Chauffeurs with Route Expertise",
    "WhyChoosedescription": "Our professional drivers are courteous, punctual, and well-acquainted with the Pune–Nashik route, including expressways and alternate paths. They ensure a timely and safe journey, with stops for refreshments or sightseeing upon request."
  },
  {
    "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Cabs",
    "WhyChoosedescription": "We maintain high hygiene and safety standards. Every Innova Crysta is cleaned and sanitized before departure and undergoes regular mechanical checks to guarantee reliable, safe travel."
  },
  {
    "WhyChooseheading": "Customizable Travel Plans",
    "WhyChoosedescription": "Choose from one-way or round-trip travel, with flexible pickup and drop locations across Pune such as Baner, Viman Nagar, Kothrud, or Hinjewadi. You can also include stops like Sula Vineyards, Trimbakeshwar Temple, or Panchavati in your itinerary."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Fees",
    "WhyChoosedescription": "Our pricing includes fuel, tolls, driver allowance, and taxes. We offer upfront fare estimates with no surprise charges, providing premium comfort at fair rates."
  },
  {
    "WhyChooseheading": "Perfect for Pilgrimage, Winery Tours, and Business Travel",
    "WhyChoosedescription": "Whether you're traveling for a spiritual journey to Trimbakeshwar, attending a corporate event, or exploring Nashik's vineyards, Innova Crysta ensures a premium travel experience tailored to your purpose."
  },
  {
    "WhyChooseheading": "24/7 Booking and Support",
    "WhyChoosedescription": "Book your Pune to Nashik Innova Crysta cab anytime—day or night. Our support team is available round-the-clock to help with bookings, rescheduling, and special requests."
  }
]
























    }

const faqData = [
    {
        question: "How can I book an Innova Crysta taxi from Pune to Nashik?",
        answer: "You can book by calling Meghana Cab at +91 9075462128 or through our website for hassle-free booking."
    },
    {
        question: "What is the distance and approximate travel time from Pune to Nashik?",
        answer: "The distance is around 210 km and the travel time is approximately 4 to 5 hours depending on traffic."
    },
    {
        question: "Is the Innova Crysta suitable for Pune to Nashik travel?",
        answer: "Yes, the Innova Crysta offers ample space, comfort, and smooth ride for long-distance travel."
    },
    {
        question: "Can I book a one-way or round trip taxi service?",
        answer: "Yes, both one-way and round-trip taxi bookings are available as per your requirement."
    },
    {
        question: "How many passengers can the Innova Crysta accommodate?",
        answer: "It comfortably seats 6 to 7 passengers along with luggage."
    },
    {
        question: "Are the vehicles sanitized before each trip?",
        answer: "Yes, all vehicles are thoroughly sanitized prior to every journey for passenger safety."
    },
    {
        question: "Do your drivers have experience with the Pune to Nashik route?",
        answer: "Absolutely, our drivers are well-acquainted with the route ensuring a safe and timely journey."
    },
    {
        question: "What does the fare include for Pune to Nashik Innova Crysta taxi service?",
        answer: "The fare includes fuel, tolls, and driver charges. Additional waiting or parking charges may apply."
    },
    {
        question: "Is the service available 24/7?",
        answer: "Yes, Meghana Cab offers round-the-clock taxi services."
    },
    {
        question: "What payment methods do you accept?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash payments."
    },
];

const testimonialsData = [
    {
        name: 'Mr. Amit Kulkarni',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“The Innova Crysta cab from Pune to Nashik was very comfortable and the driver was professional and courteous.”',
    },
    {
        name: 'Ms. Priya Deshpande',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Excellent taxi service for Nashik trip. The vehicle was clean, and the overall experience was seamless.”',
    },
];
























































































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];







const puneToNashikInnovaSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Pune to Nashik Innova Crysta Taxi Service",
  "description": "Book chauffeur-driven Innova Crysta taxi service from Pune to Nashik. Available for one way, round trip, AC taxi rides, private trips, and online booking for family and business travel.",
  "provider": {
    "@type": "Organization",
    "name": "Meghana Cabs",
    "url": "https://www.meghanacabs.com"
  },
  "serviceType": "Outstation Taxi Service",
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/pune-to-nashik-innova-crysta-cab"
  }
};







    return (
        <div>

<Helmet>
  <title>Pune to Nashik Innova Crysta Taxi Service | Comfortable Outstation Ride</title>
  <meta
    name="description"
    content="Chauffeur-driven Innova Crysta taxi service from Pune to Nashik. One way, round trip, AC, private taxi with online booking options."
  />
  <meta
    name="keywords"
    content="Pune to Nashik Innova Crysta Cab Booking, One Way Innova Crysta Pune Nashik, Round Trip Innova Crysta Pune Nashik, AC Innova Crysta Taxi Pune Nashik, Chauffeur Driven Innova Crysta Pune Nashik, Private Innova Crysta Taxi Pune Nashik, Online Booking Innova Crysta Cab Pune Nashik, Family Innova Crysta Trip Pune Nashik"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneToNashikInnovaSchema)}
  </script>
</Helmet>



            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/Keywords/27.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetonashikinnovacrysta;